package one.healthium.insights.di

import kotlinx.serialization.json.Json
import kotlinx.serialization.modules.SerializersModule
import one.healthium.channels.di.channelsModule
import one.healthium.insights.data.AppContentRepository
import one.healthium.insights.data.AppShoppingListDataRepository
import one.healthium.insights.data.AppWorkoutsRepository
import one.healthium.insights.data.mapper.ActionMapper
import one.healthium.insights.data.mapper.ContentMapper
import one.healthium.insights.data.mapper.ContentScreenMapper
import one.healthium.insights.data.mapper.MealNutritionMapper
import one.healthium.insights.data.mapper.SavedContentMapper
import one.healthium.insights.data.sources.network.ContentApiClient
import one.healthium.insights.data.sources.storage.SavedContentStorage
import one.healthium.insights.data.utils.CustomSerializerModules
import one.healthium.insights.domain.content.ContentRepository
import one.healthium.insights.domain.shopping_list.ShoppingListDataRepository
import one.healthium.insights.domain.workouts.WorkoutsRepository
import one.healthium.insights.ui.content.ContentViewModel
import one.healthium.insights.ui.insights.InsightsViewModel
import one.healthium.insights.ui.shopping_list.ShoppingListViewModel
import one.healthium.meal_plans.di.mealPlansDataModule
import org.koin.core.module.dsl.factoryOf
import org.koin.core.module.dsl.singleOf
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.bind
import org.koin.dsl.module

val insightsModule = module {
    includes(mealPlansDataModule, channelsModule)
    singleOf(::CustomSerializerModules)
    single {
        val customSerializerModules = get<CustomSerializerModules>()
        val json = Json {
            ignoreUnknownKeys = true
            isLenient = true
            serializersModule = SerializersModule {
                customSerializerModules.modules.forEach { include(it) }
            }
        }
        val baseHttpClient = ContentApiClient.createBaseHttpClient(json)
        ContentApiClient.factory(baseHttpClient, get())
    }

    singleOf(::SavedContentStorage)

    singleOf(::AppWorkoutsRepository) bind WorkoutsRepository::class
    singleOf(::AppContentRepository) bind ContentRepository::class
    singleOf(::AppShoppingListDataRepository) bind ShoppingListDataRepository::class

    factoryOf(::ContentMapper)
    factoryOf(::ContentScreenMapper)
    factoryOf(::ActionMapper)
    factoryOf(::MealNutritionMapper)
    factoryOf(::SavedContentMapper)

    viewModelOf(::InsightsViewModel)
    viewModelOf(::ContentViewModel)
    viewModelOf(::ShoppingListViewModel)
}